import { Component, Inject, OnInit } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import {
	MAT_BOTTOM_SHEET_DATA,
	MatBottomSheetRef,
} from "@angular/material/bottom-sheet";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { TranslateService } from "@ngx-translate/core";
import { CompanyDataService } from "src/app/company/_services/company.data.service";
import { LoadingService } from "src/app/share/service/loading.service";

@Component({
	selector: "app-create-update-company-dialog",
	templateUrl: "./create-update-company-dialog.component.html",
	styleUrls: ["./create-update-company-dialog.component.scss"],
})
export class CreateUpdateCompanyDialogComponent implements OnInit {
	formGroup: UntypedFormGroup;
	data: any;
	bankSelectionList: any[] = [];
	vehicleTypeAccessList: any[] = [];
	selectedVehicleAccess: any[] = [];
	updateCompany: boolean = false;

	constructor(
		private bottomSheetRef: MatBottomSheetRef<CreateUpdateCompanyDialogComponent>,
		private loadingService: LoadingService,
		private translateService: TranslateService,
		private companyDataService: CompanyDataService,
		@Inject(MAT_BOTTOM_SHEET_DATA) data: any,
	) {
		this.data = data.data;
		this.bankSelectionList = data.bankSelectionList;
		this.vehicleTypeAccessList = data.vehicleTypeAccessList;
		this.updateCompany = data.updateCompany;
	}

	public get dialogBtn(): string {
		return this.updateCompany ? 
			this.translateService.instant("common.edit") : 
			this.translateService.instant("common.create" )
	}

	public get dialogTitle(): string {
		return this.updateCompany ? 
			this.translateService.instant("company.editCompany") : 
			this.translateService.instant("company.createCompany" )
	}

	ngOnInit(): void {
		this.formGroup = new UntypedFormGroup({
			name: new UntypedFormControl(null, [Validators.required]),
			address: new UntypedFormControl(null),
			ssmid: new UntypedFormControl(null, [Validators.required]),
			isOnlinePayment: new UntypedFormControl(null, [Validators.required]),
			parentCompanyName: new UntypedFormControl(null),
			bankId: new UntypedFormControl(null),
			bankAccNo: new UntypedFormControl(null),
			accHolderName: new UntypedFormControl(null),
			vehicleTypeAccess: new UntypedFormControl(null, [Validators.required]),
		});

		this.companyDataService
						.getVehicleTypeAccessByDealerId(this.data?.id)
						.subscribe((value) => {
							this.selectedVehicleAccess = value;
							this.formGroup.controls.vehicleTypeAccess.setValue(this.selectedVehicleAccess);
					})

		if (this.updateCompany) {
			const isOnlinePayment =
				this.data.paymentMethod == "Online" ? true : false;

			
			this.formGroup.patchValue({
				name: this.data?.name,
				address: this.data?.address,
				ssmid: this.data?.ssmid,
				isOnlinePayment: isOnlinePayment,
				parentCompanyName: this.data?.parentCompanyName,
				accHolderName: this.data?.accHolderName,
				bankId: this.data?.bankId,
				bankAccNo: this.data?.bankAccNo,
				vehicleTypeAccess: this.selectedVehicleAccess
			});
			this.formGroup.get("isOnlinePayment").disable();
		}
	}

	public close(event: MouseEvent): void {
		this.bottomSheetRef.dismiss();
		event.preventDefault();
	}

	public createUpdateCompany(): void {
		if (!this.formGroup.valid) return;
		this.loadingService.loadingOn(true);

		let reqObj = {};
		for (let key in this.formGroup.value) {
			if (this.formGroup.value[key]) {
				reqObj[key] = this.formGroup.value[key];
			}
		}
		this.bottomSheetRef.dismiss(reqObj);
	}
}
